import { IconProps } from "@radix-ui/react-icons/dist/types";
import * as React from "react";

export const ArrowStraightIcon = React.memo(function ArrowStraightIcon({
  color = "currentColor",
  ...props
}: IconProps) {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13 4.5C13 4.77614 12.7761 5 12.5 5C12.2238 5 12 4.77614 12 4.5V3.70703L2.85348 12.8535C2.65822 13.0488 2.34171 13.0488 2.14645 12.8535C1.95118 12.6583 1.95118 12.3417 2.14645 12.1465L11.2929 3H10.5C10.2238 3 9.99996 2.77614 9.99996 2.5C9.99996 2.22386 10.2238 2 10.5 2H13V4.5Z"
        fill={color}
      />
    </svg>
  );
});
